import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteParams } from '@/context/routeParamsContext';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';
import LFLink from './LFLink';
import { IconCity } from '../icons';

const AirportLinkWithImage = ({ background, airport, ...restofProps }) => {
  const { product } = useRouteParams();
  const cmsImgBaseUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);

  const { iata, image, name, city } = airport;
  const urlAirportIata = iata ? `/${iata}` : '';

  return (
    <LFLink
      key={`featured-airports-link-${iata}`}
      element="featured-airports-link"
      className="tw-flex tw-max-w-80 tw-text-balance"
      to={`${product}${urlAirportIata}/`}
      onClickHandler={restofProps?.onClickHandler}
    >
      {image ? (
        <img
          alt=""
          src={`${cmsImgBaseUrl}${image}`}
          className="tw-h-12 tw-w-12 tw-rounded-lg tw-bg-gray-300"
        />
      ) : (
        <IconCity />
      )}
      <div className="tw-ml-4 tw-flex tw-flex-col">
        <span
          className={
            background === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-800'
          }
        >
          {name}
        </span>
        <span
          className={
            background === 'dark'
              ? 'tw-text-gray-300'
              : 'tw-text-xs tw-text-gray-700'
          }
        >
          {iata} • {airport.location ? airport.location.city : city}
        </span>
      </div>
    </LFLink>
  );
};

export default AirportLinkWithImage;
